export class CloneHelper {

    /*Solution from http://stackoverflow.com/questions/728360/most-elegant-way-to-clone-a-javascript-object*/
    public static clone<T>(object: T): T {
        if (object) {
            try {
                return JSON.parse(JSON.stringify(object));
            } catch (e) {
                return object;
            }
        } else {
            return object;
        }
    }

    //This clones functions as well
    public static cloneObject<T>(obj: T): T {
        if ((obj === null) || (typeof obj !== 'object') || (obj instanceof Blob) || (obj instanceof File) || (obj instanceof Date)) {
            return obj;
        }

        let temp: any;
        try {
            const constructor: () => void = <() => void>obj.constructor;
            temp = new constructor(); // give temp the original obj's constructor
        } catch (e) {
            temp = Object.create(null);
        }

        for (const key in obj) {
            temp[key] = CloneHelper.cloneObject(obj[key]);
        }

        return temp;
    }

}
